<template>
    <div>

        <div>
            <v-container>
                <v-row align="end">
                    <v-col cols="12" md="6" class="px-md-12">
                        <v-img :src="'https://artlesscms.actstudio.xyz/'+product.cover.path"></v-img>
                    </v-col>
                    <v-col cols="12" md="6" class="px-md-12 pb-md-1" style="border-left: 2px solid #979797;">

                        <div class="pl-md-12">

                            <span class="CSCategoryTitle uppercase color-cs-1 mb-10 d-block">{{product.name}} VARIATIONS</span>

                            <div class="CSVariationsContainer">

                                <template v-for="(variation,v) in variations">

                                    <template v-if="variation.product._id == product._id">
                                        <span class="d-block cursor-pointer CSProductName not-text-decoration color-cs-2 pb-3" :key="'variation-'+v" @click="variationActive = v" v-bind:class="{'bold':variationActive == v}">
                                            {{variation.name}}
                                        </span>
                                    </template>
                                </template>
                            </div>

                            <span id="materials-span" class="gtAmerica-extended-bold d-block mt-6 CSCategoryTitle mb-0">MATERIALS</span>

                            <template v-for="(variation,v) in variations">
                                <transition name="fade-transition" :key="'v-'+v">
                                    <div class="materials-container" v-html="variation.materials" v-show="variationActive == v">
                                    </div>
                                </transition>
                            </template>
                        
                        </div>
                    </v-col>
                </v-row>

            </v-container>

            <v-container :fluid="screenWidth > 599" class="mt-md-12" >
                <v-row class="my-md-6">
                    <v-col cols="12" class="px-md-0">
                        <div class="owl-carousel-custom" style="position: relative;">
                            <template v-for="(variation,v) in variations">
                                <carousel :autoplay="false" :nav="false" :items="2" :key="'car-'+v" :dots="false" v-if="variationActive == v" :responsive="{0:{items:1},600:{items:2}}">
                                    <template v-for="(image, i) in variation.images">
                                        <img :src="'https://artlesscms.actstudio.xyz/'+image.path" :key="'image-'+i" class="img-cs-carousel"></img>
                                    </template>

                                    <template slot="prev">
                                        <span class="prev-icon"><v-icon size="36">mdi-chevron-left</v-icon></span>
                                    </template>

                                    <template slot="next">
                                        <span class="next-icon"><v-icon size="36">mdi-chevron-right</v-icon></span>
                                    </template>



                                </carousel>    
                            </template> 
                        </div>
                    </v-col>
                </v-row>
            </v-container>

            <v-container class="pb-12">
                <v-row v-if="screenWidth < 600">
                    <v-col v-for="(category,c) in categories" :key="'category-'+c" cols="6" class="text-center">
                        <router-link :to="'/cs/'+category.url" class="not-text-decoration">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+category.icon.path" width="200"></v-img>

                            <span class="d-block">{{category.name}}</span>
                        </router-link>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="screenWidth > 599">
                    <v-col v-for="(category,c) in categories" :key="'category-'+c" cols="auto" class="text-center">
                        <router-link :to="'/cs/'+category.url" class="not-text-decoration">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+category.icon.path" width="200"></v-img>

                            <span class="d-block">{{category.name}}</span>
                        </router-link>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
    components: { carousel },
    data(){
        return{
            categories:[],
            product:{

            },
            variations: [],
            variationActive: 0
        }
    },
    computed:{
        screenWidth: function(){
            return this.$vuetify.breakpoint.width;
        }
    },
    beforeMount: function(){

        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/CSProduct?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    url: this.$route.params.url
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.product = res.entries[0]))
        .then(() => {
            var breadcrumbs = [
                {
                    text: 'Home',
                    link: '/',
                    isLink: true
                },
                {
                    text: this.product.name,
                    link: '/materials',
                    isLink: false
                }
            ];
            this.$emit("updateStatus", breadcrumbs);
        })


        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/CSVariations?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.variations = res.entries))
        .then(() => (this.setActive()))

        fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/CSCategory?token=a15be93e9cdb43ca2b3778c2077c26', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                populate: 0
            })
        })
        .then(res=>res.json())
        .then(res => this.categories = res.entries )
    },
    mounted: function(){
        this.$emit("update", 1);

        var aux = this;
        gtag('config', 'UA-26953667-1', {
            'page_title' : 'Home',
            'page_path': '/CS/product/'+aux.$route.params.url
        });
    },
    methods:{
        setActive: function(){
            var found = false;
            for (let index = 0; index < this.variations.length; index++) {
                if(this.variations[index].product.url == this.$route.params.url){
                    if(!found){
                        this.variationActive = index;
                        found = true;
                    }
                }
                
            }
        }
    },
    watch:{
        variationActive: function(){
            if(this.screenWidth < 600){
                this.$vuetify.goTo('#materials-span');
            }
        }
    }
}
</script>